import React, { useContext, useEffect, useState } from 'react'
import { chatbotListInterface, mapParentChatbotWithSubChatbotPayload, SubChatbot } from '../../../models/axiosModel'
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import autoCompleteStyle from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import subChatbotStyle from "../../../assets/styles/componentStyles/subChatbotStyles/subChatbot.module.scss";
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import GlobalButton from '../../utility/globalButton/button';
import globalStyles from "../../../assets/styles/global.module.scss"
import { filterCustomChatbots } from '../../../utils/constants';


interface CreateUpdateSubChatbotDialogProps { 
    subAiChatbotData: SubChatbot[],
    requestedSubChatbotData: mapParentChatbotWithSubChatbotPayload | null, 
    tempSubChatbotData: mapParentChatbotWithSubChatbotPayload | null,
    setFlagCreateUpdateDialog: React.Dispatch<React.SetStateAction<boolean>>, 
    onClickOfSave: (payload: mapParentChatbotWithSubChatbotPayload) => void,
} 

const CreateUpdateSubChatbotDialog: React.FC<CreateUpdateSubChatbotDialogProps> = (props) => {

    const { subAiChatbotData, requestedSubChatbotData, tempSubChatbotData, setFlagCreateUpdateDialog, onClickOfSave } = props;
    const { chatbotList, GetChatbotListApi } = useContext(ChatbotContext) as ChatbotContextPayload; 
    const { flagLoading, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    
    const [searchParams, setSearchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');

    const [payload, setPayload] = useState<mapParentChatbotWithSubChatbotPayload>(requestedSubChatbotData ? requestedSubChatbotData : {
        sub_chatbot_id: "",  
        parent_chatbot_id: Number(chatbot_id),
        chatbot_id: 0,  
        flag_deleted: false,
        sub_chatbot_data: {
            sub_chatbot_data_id: "",
            sub_chatbot_data_name: "",
            sub_chatbot_data_purpose: "",
        }
    }); 

    const GetChatbotListApiCall = async () => {
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: true }));
        const res = await GetChatbotListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: false }));
    } 

    const disableSaveBtn = () => { 
        if(JSON.stringify(payload) == JSON.stringify(tempSubChatbotData)){
            return true;
        }
        else if(payload.chatbot_id != 0 && payload.sub_chatbot_data.sub_chatbot_data_name.trim().length > 0 && payload.sub_chatbot_data.sub_chatbot_data_purpose.trim().length > 0){
            return false;
        }
        return true;
    } 

    useEffect(() => {
        if(!chatbotList){
            GetChatbotListApiCall();
        }
    }, [chatbotList])

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}> {requestedSubChatbotData ? "Edit Sub Chatbot" : "Add Sub Chatbot"}</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>
                                <Grid item xs={12}>
                                    <Grid container className={subChatbotStyle.inputFieldContainer}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Sub Chatbot <span className={subChatbotStyle.requiredColor}>*</span></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${autoCompleteStyle.whatsappCampaignDropDowns} ${subChatbotStyle.subChatbotAutoComplete}`}
                                                options={chatbotList ? filterCustomChatbots(chatbotList)?.filter((chatbot: chatbotListInterface) => chatbot.chatbot_id != chatbot_id) : []} 
                                                value={(chatbotList && payload.chatbot_id != 0) ? chatbotList.find((chatbot: chatbotListInterface) => chatbot.chatbot_id == String(payload.chatbot_id)) : null}
                                                getOptionLabel={(option) => option ? option.chatbot_name : ""} 
                                                renderInput={(params) => <TextField {...params} placeholder="Select Sub Chatbot" />}
                                                onChange={(_, value: chatbotListInterface | null) => {
                                                    setPayload({
                                                        ...payload, 
                                                        chatbot_id: value ? Number(value.chatbot_id) : 0,
                                                    })
                                                }}
                                                renderOption={(props, option) => {
                                                    return <li {...props} key={`${option?.chatbot_id}-${option?.chatbot_name}`}>
                                                        {option?.chatbot_name ?? ''}
                                                    </li>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container className={subChatbotStyle.inputFieldContainer}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Mapping Name <span className={subChatbotStyle.requiredColor}>*</span></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField 
                                                className={`${style.campaignContactPopupTextField} ${globalStyles.fullwidth}`} 
                                                value={payload.sub_chatbot_data.sub_chatbot_data_name}
                                                onChange={(e) => {
                                                    setPayload({
                                                        ...payload, 
                                                        sub_chatbot_data: {
                                                            ...payload.sub_chatbot_data, 
                                                            sub_chatbot_data_name: e.target.value,
                                                        }  
                                                    })
                                                }}
                                                placeholder={`Enter Mapping Name`}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container className={subChatbotStyle.inputFieldContainer}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Mapping Purpose <span className={subChatbotStyle.requiredColor}>*</span></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <textarea
                                                rows={3}
                                                placeholder='Enter Mapping Purpose'
                                                className={subChatbotStyle.purposeTextArea}
                                                value={payload.sub_chatbot_data.sub_chatbot_data_purpose}
                                                onChange={(e) => {
                                                    setPayload({
                                                        ...payload, 
                                                        sub_chatbot_data: {
                                                            ...payload.sub_chatbot_data, 
                                                            sub_chatbot_data_purpose: e.target.value,
                                                        }
                                                    })
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container className={subChatbotStyle.popupBtnsContainer}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => { 
                                            if(requestedSubChatbotData){
                                                setPayload(requestedSubChatbotData);    
                                            }else{
                                                setPayload({
                                                    sub_chatbot_id: "",  
                                                    parent_chatbot_id: 0,
                                                    chatbot_id: 0,  
                                                    flag_deleted: false,
                                                    sub_chatbot_data: {
                                                        sub_chatbot_data_id: "",
                                                        sub_chatbot_data_name: "",
                                                        sub_chatbot_data_purpose: "",
                                                    }
                                                })
                                            }
                                            setFlagCreateUpdateDialog(false);
                                        }}
                                    >
                                    </GlobalButton>
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={requestedSubChatbotData ?  "Save" : "Add"}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={disableSaveBtn()}
                                        onClick={() => {
                                            onClickOfSave(payload); 
                                            setFlagCreateUpdateDialog(false);
                                        }}
                                    >
                                    </GlobalButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateUpdateSubChatbotDialog
